export default __webpack_public_path__ + "static/media/java.d80d1b34.svg";